import { fetchBalance } from "../utils/getCreditApp";


document.addEventListener('DOMContentLoaded', async () => {


  const getElements = () => {
    const btnCheckoutAll = document.querySelectorAll('.btn-checkout-default');
    const btnCheckoutOpenModalAll = document.querySelectorAll('.btn-open-popup');

    return {
      btnCheckoutAll,
      btnCheckoutOpenModalAll
    }
  }
  

  const loadScriptModalAlert = () => {
    const modal = document.getElementById('modal-credit');
    const closeBtn = document.querySelector('.close');
   
    const { btnCheckoutAll,  btnCheckoutOpenModalAll} = getElements();

    btnCheckoutAll.forEach((btnCheckout)=> {
      btnCheckout.classList.add('button-hidden');
    });

    btnCheckoutOpenModalAll.forEach((btnCheckoutOpenModal)=> {
      btnCheckoutOpenModal.classList.remove('button-hidden');

      btnCheckoutOpenModal.addEventListener('click', (event) => {
        event.preventDefault();
        modal.style.display = 'block';
        
        const cartNotification = document.querySelector('#cart-notification');
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartNotification && cartNotification.classList.contains('active')) {

          cartNotification.classList.remove('active');
        }
        if (cartDrawer && cartDrawer.classList.contains('active')) {
          cartDrawer.classList.remove('active');
        }
        
      });
    });


    console.log('happened', document.querySelectorAll('.close'));
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });

  }

  const loadOpenAppCreditPopup = () => {
    const modal = document.getElementById('modal-credit');

    const buttonOpenApp = document.querySelector('#button-open-credit');
    const buttonAppCredit = document.querySelector('#sci_div_icon');

    const { btnCheckoutAll,  btnCheckoutOpenModalAll} = getElements();


    buttonOpenApp.addEventListener('click', () => {

      btnCheckoutAll.forEach(btnCheckout => {
        btnCheckout.classList.remove('button-hidden');
      })
      btnCheckoutOpenModalAll.forEach(btnCheckoutOpenModal=> {

        btnCheckoutOpenModal.classList.add('button-hidden');
      })
      modal.style.display = 'none';
      buttonAppCredit.click();
    })
  }

  
  
  const balance = await fetchBalance();

  console.log('result', Number(balance));

  if (Number(balance) > 0) {

    loadScriptModalAlert();
    loadOpenAppCreditPopup();
    return
  }
  const btnCheckout = document.querySelector('#checkout');
  btnCheckout.classList.remove('button-hidden');


  
});
